export default __webpack_public_path__ + "static/media/94.fe31de7d.jpg";